module.exports = __webpack_public_path__ + "img/add.af7ffdab.png";